module.exports = new __parcel__URL__("pdfDocIcon.fa5a48f0.svg").toString();